import React from "react";
import { CONTENT_TYPES } from "./constants";
import Typography from "components/Typography";

export const StringItem = (props) => {
  const {
    data,
    headerStyle,
    headerProps,
    textStyle,
    textProps
  } = props;

  const { id, style, value } = data;

  if (style === CONTENT_TYPES.HEADER) {
    return (
      <Typography
        className={headerStyle}
        id={id}
        {...headerProps}
      >
        {value}
      </Typography>
    );
  } else {
    return (
      <Typography
        className={textStyle}
        id={id}
        {...textProps}
      >
        {value}
      </Typography>
    );
  }
};
